<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog
      :title="isNotNew ? $t('servicesystem.common_objects.commonterms.edit_object', { okey: $t(objectname) }) : $t('servicesystem.common_objects.commonterms.new_object', { okey: $t(objectname) })"
      :externaltrigger="dialogtrigger" :externalCloseTrigger="closetrigger">

      <template v-slot:content>
        <v-form v-model="valid" ref="dialigform">
          <slot name="dialog-content" :handlevalid="setValid" :edititem="editObject" :readonly="readonly"
            :trigger="externaltrigger">
            dialog content
          </slot>
        </v-form>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++" color="primary" outlined>
          {{ $t('servicesystem.common_objects.commonterms.cancel') }}
        </v-btn>

        <slot name="center-button" :edititem="editObject" />

        <v-btn v-if="!readonly" :loading="loading" :disabled="loading" :color="valid ? 'primary' : 'disabled'"
          @mouseenter="$refs.dialigform.validate()" @click="!valid ? null : handleSave()">
          {{ isNotNew ? $t('servicesystem.common_objects.commonterms.save') :
            $t('servicesystem.common_objects.commonterms.create') }}
        </v-btn>
      </template>

    </slotted-dialog>
  </v-form>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "ConfigDialog",
  props: {
    objectname: String,
    externaltrigger: [Number, Boolean],
    externalclosetrigger: [Number, Boolean],
    item: Object,
    methodconfigurations: Object,
    readonly: {
      type: Boolean,
      default: false
    },
  },
  components: {
    SlottedDialog,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      editObject: null,
      valid: false,
      loading: false,
    };
  },

  mounted() {
    this.parseItem();
  },

  methods: {
    updateValue(update) {
      this.editObject[update.key] = update.value;
    },

    async handleSave() {
      this.loading = true;
      var methodconfig = this.isNotNew ? this.methodconfigurations.Change : this.methodconfigurations.Create;
      var emitname = this.isNotNew ? "Changed" : "Added";

      await this.save(methodconfig, emitname);
    },

    async save(methodconfig, emitEventName) {
      if (methodconfig) {
        if (methodconfig.IsClientApiMethod) {
          const wasnew = !this.isNotNew;
          var dto = Object.assign({}, this.editObject);
          await this[methodconfig.Name](dto)
            .then((response) => {
              response.new = wasnew;
              response.changed = !wasnew;
              this.$emit(emitEventName, response);
              this.closetrigger++;
            })
            .catch(() => { })
            .finally(() => {
              this.loading = false;
            });
        } else {
          console.error("Unknown method holder for method config", methodconfig);
        }
      } else {
        console.error("Invalid method config", methodconfig);
      }
    },

    parseItem() {
      this.editObject = Object.assign({}, this.item);
    },

    setValid(e) {
      this.valid = e;
    },
  },

  computed: {
    isNotNew() {
      return this.item && this.item.Id;
    },
  },

  watch: {
    externaltrigger: function () {
      this.parseItem();
      this.dialogtrigger++;
    },
    externalclosetrigger: function () {
      this.closetrigger++;
    },

  },
};
</script>